import { QuoteFormRequestParams, QuoteFormSearchRequestQuery } from '@lio/api-types';

export const quoteFormQueryKeys = {
  resource: 'quote-forms' as const,
  get: (quoteId?: string) => [quoteFormQueryKeys.resource, quoteId] as const,
  searchWithParams: (params?: QuoteFormRequestParams & QuoteFormSearchRequestQuery) =>
    [...quoteFormQueryKeys.get(params?.quoteId)] as const,
  updateQuoteFormAttributesMutationKey: ['quote-form-attributes'] as const,
};
